import { useState, useCallback } from 'react';
import { ErrorCarga } from '../../comun/components/models/comunModels';
import { ListaCargaCobradorDTO, ResultadoCargaArchivoCobro } from '../models/cargaCobro';
import { listarCarga } from '../services/servicesCargaCobro';
import { StatusCode } from '../../../../utils/enums';

function useCargarCobrador() {
    const [error, setError] = useState<ErrorCarga[]>([]);
    const [data, setData] = useState<ListaCargaCobradorDTO[]>([]);
    const [archivoTxt, setArchivoTxt] = useState<string>();

    const listar = useCallback(async (data: File) => {
        setError([]);
        setData([]);

        const respuesta = await listarCarga(data);
        if (respuesta.status !== StatusCode.Ok)
            return;

        const resultado: ResultadoCargaArchivoCobro = respuesta.data;
        setData(resultado.registrosValidos);
        setArchivoTxt(resultado.archivoTXT);

        if (resultado.tieneErrores)
            setError(resultado.errores);

    }, []);

    const limpiar = useCallback(() => {
        setError([]);
        setData([]);
        setArchivoTxt('');
    }, []);

    return { data, error, archivoTxt,listar, limpiar };
}

export default useCargarCobrador;